export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7400.f4ab716f.jpg";